/* GENERATED by pdp/build-theme.mjs — VAT estimator. Rates: design-system/data/vat-rates.json (as of 2026-07-28). */
(function(){
  if (window.__rossumVat) return;
  window.__rossumVat = true;
  var RATES = {"AT":[20,""],"BE":[21,""],"BG":[20,""],"HR":[25,""],"CY":[19,""],"CZ":[21,""],"DK":[25,""],"EE":[24,""],"FI":[25.5,""],"FR":[20,""],"DE":[19,""],"GR":[24,""],"HU":[27,""],"IE":[23,""],"IT":[22,""],"LV":[21,""],"LT":[21,""],"LU":[17,""],"MT":[18,""],"NL":[21,""],"PL":[23,""],"PT":[23,""],"RO":[21,""],"SK":[23,""],"SI":[22,""],"ES":[21,""],"SE":[25,""],"GB":[20,""],"CH":[8.1,""],"NO":[25,""],"IS":[24,""],"TR":[20,""],"UA":[20,""],"GE":[18,""],"MD":[20,""],"AU":[10,""],"NZ":[15,""],"JP":[10,""],"KR":[10,""],"SG":[9,""],"CN":[13,""],"IN":[18,""],"TH":[7,""],"MY":[10,""],"ID":[11,""],"PH":[12,""],"VN":[10,""],"IL":[18,""],"AE":[5,""],"SA":[15,""],"ZA":[15,""],"EG":[14,""],"NG":[7.5,""],"MX":[16,""],"BR":[17,""],"CL":[19,""],"AR":[21,""],"CO":[19,""],"PE":[18,""],"CA":[5,"subnational"],"HK":[0,"none"],"TW":[5,""]};
  var NOTES = {"subnational":"Rate is the national/federal rate only. Sub-national taxes (e.g. Canadian provincial PST/HST) are additional, so the true charge is higher than shown.","none":"No VAT/GST on imports of this kind. The buyer may still owe duty and a carrier clearance fee."};
  var KEY = 'rossum:vat-country';
  var current = null;
  var fmt = function(cents){
    try { return new Intl.NumberFormat(undefined,{style:'currency',currency:'USD',maximumFractionDigits:0}).format(cents/100); }
    catch(e){ return '$' + Math.round(cents/100); }
  };
  var setText = function(root, sel, text){ var n = root.querySelector(sel); if (n) n.textContent = text; };
  var apply = function(iso){
    current = iso || null;
    var rate = iso ? RATES[iso] : null;
    var roots = document.querySelectorAll('[data-vat-est]');
    for (var i=0;i<roots.length;i++){
      var root = roots[i];
      var sel = root.querySelector('[data-vat-country]');
      if (sel && sel.value !== (iso || '')) sel.value = iso || '';
      var out = root.querySelector('[data-vat-out]');
      var note = root.querySelector('[data-vat-note]');
      var basis = parseInt(root.getAttribute('data-basis'), 10);
      if (!rate || isNaN(basis) || basis <= 0){
        if (out) out.hidden = true;
        if (note) note.hidden = true;
        continue;
      }
      if (out){
        out.hidden = false;
        setText(out, '[data-vat-pct]', rate[0] + '%');
        setText(out, '[data-vat-amt]', fmt(basis * rate[0] / 100));
        setText(out, '[data-vat-base]', fmt(basis));
      }
      if (note){
        var n = rate[1] ? NOTES[rate[1]] : '';
        note.hidden = !n;
        note.textContent = n || '';
      }
    }
    // Product table on the VAT page — every row follows the one picker.
    var rows = document.querySelectorAll('[data-vat-row]');
    for (var j=0;j<rows.length;j++){
      var b = parseInt(rows[j].getAttribute('data-basis'), 10);
      if (isNaN(b)) continue;
      var c = rows[j].querySelector('[data-vat-cell]');
      var t = rows[j].querySelector('[data-vat-total]');
      if (!rate){ if (c) c.textContent = '—'; if (t) t.textContent = '—'; continue; }
      if (c) c.textContent = fmt(b * rate[0] / 100);
      if (t) t.textContent = fmt(b + b * rate[0] / 100);
    }
  };
  // Delegated: the cart drawer swaps this markup out on every cart change, so binding directly to
  // a select would silently stop working after the first add-to-cart.
  document.addEventListener('change', function(e){
    var t = e.target;
    if (!t || !t.hasAttribute || !t.hasAttribute('data-vat-country')) return;
    try { t.value ? localStorage.setItem(KEY, t.value) : localStorage.removeItem(KEY); } catch(err){}
    apply(t.value);
  });
  var init = function(){
    // Precedence: a server-rendered customer country beats a local choice on this device, so one
    // browser cannot silently contradict the account — the rule the light/dark preference uses.
    // Nothing writes it yet (localStorage only, per Chris 2026-07-28); this is the seam.
    var seeded = document.querySelector('[data-vat-default]');
    var stored = null;
    try { stored = localStorage.getItem(KEY); } catch(e){}
    var initial = (seeded && seeded.getAttribute('data-vat-default')) || current || stored;
    if (initial && RATES[initial]) apply(initial);
    else suggest();
  };
  // No choice yet: start on the visitor's own country, from the worker's /geo (the IP country the
  // dealer list and the support form already use; Chris, 2026-10-22: "automatically suggest the VAT
  // country when the user is in the cart based on their IP address"). A suggestion, not a choice: it
  // is not stored, and a country picked before the answer arrives wins. Asked once per page; a
  // failed or blocked fetch, or a country with no rate (the US), leaves the picker as it was.
  var asked = false;
  var suggest = function(){
    var root = document.querySelector('[data-vat-est][data-geo-url]');
    if (asked || !root || !window.fetch) return;
    asked = true;
    fetch(root.getAttribute('data-geo-url'), { credentials: 'omit' })
      .then(function(r){ return r.ok ? r.json() : null; })
      .then(function(g){
        var code = g && typeof g.country === 'string' ? g.country.toUpperCase() : '';
        if (!current && RATES[code]) apply(code);
      })
      .catch(function(){});
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  // Re-apply when the drawer re-renders. Debounced; cheap because apply() is a handful of writes.
  if (window.MutationObserver){
    var pending = 0;
    new MutationObserver(function(){
      clearTimeout(pending);
      pending = setTimeout(function(){ if (current) apply(current); else init(); }, 60);
    }).observe(document.body, { childList: true, subtree: true });
  }
})();
